import { ArticleResolution } from '@wix/ambassador-cc-kb-server-v1-article-translation/types';
import { Box, Tag, Text, Tooltip } from '@wix/design-system';
import { useTranslation } from '@wix/wix-i18n-config';
import React, { FC } from 'react';

import { TLocalesKeys } from '../../../../types';
import { HelpCenterArticle } from '../../types';
import s from './styles.scss';

export interface ResolutionTagProps {
  article: HelpCenterArticle;
}

export const statusToClass: Record<string, string> = {
  [ArticleResolution.COLLECTING_VOTES]: s.collectingVotes,
  [ArticleResolution.LAUNCHED]: s.released,
};

const labelKeyByResolution: Record<string, TLocalesKeys> = {
  [ArticleResolution.COLLECTING_VOTES]: 'article_resolution_110',
  [ArticleResolution.LAUNCHED]: 'article_resolution_116',
};

const tooltipKeyByResolution: Record<string, TLocalesKeys> = {
  [ArticleResolution.COLLECTING_VOTES]: 'article_resolution_tooltip_110',
  [ArticleResolution.LAUNCHED]: 'article_resolution_tooltip_116',
};

export const ResolutionStatusTag: FC<ResolutionTagProps> = ({ article }) => {
  const { t } = useTranslation();
  const { resolution } = article;

  if (!resolution || !labelKeyByResolution[resolution]) {
    return null;
  }

  return (
    <Box>
      <Tooltip size="small" content={t(tooltipKeyByResolution[resolution])}>
        <Tag
          size="small"
          className={`${s.statusTag} ${statusToClass[resolution]}`}
          id={`${article.resolution}`}
          theme="warning"
          removable={false}
        >
          <Text size="small">{t(labelKeyByResolution[resolution])}</Text>
        </Tag>
      </Tooltip>
    </Box>
  );
};
